import { render, staticRenderFns } from "./serviceDetail.vue?vue&type=template&id=75559ae4&scoped=true"
import script from "./serviceDetail.vue?vue&type=script&lang=js"
export * from "./serviceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75559ae4",
  null
  
)

export default component.exports